import { Button, ButtonProps } from "@mantine/core"
import { useNavigate, NavigateOptions } from "@tanstack/react-router"

interface Props extends ButtonProps {
  navigateOptions: NavigateOptions
}

export function NavButton({ navigateOptions, ...props }: Props) {
  const navigate = useNavigate()
  return <Button onClick={() => navigate(navigateOptions)} {...props} />
}
